// Nordstealth — Laufwerk der Bewertungsschiene.
//
// Ausgelagert am 02.09.2026 aus den beiden custom_liquid-Bloecken
// (templates/product.json Sektion custom_liquid_fGqKAe und
// templates/index.json Sektion custom_liquid_tLGHhN), die es bis dahin
// zeichengleich doppelt trugen. Gruende: der 50-KB-Deckel von custom_liquid war
// mit 48,4 KB fast erreicht, das Skript hielt als <script> ohne defer den
// Parser an, und weil das HTML ohne cache-control kommt, wurde es bei jedem
// Seitenaufruf neu uebertragen.
//
// Eingebunden wird es aus beiden Bloecken mit
//   <script src="{{ 'ns-bewertungsschiene.js' | asset_url }}" defer></script>
// Es laeuft je Seite nur einmal (wurzel.dataset.nsRevInit) und tut nichts,
// wenn es auf einer Seite ohne Schiene landet.
//
// Wer hier etwas aendert: danach node scripts/check-slider.mjs laufen lassen.
// Der prueft Dauerlauf, Naht, Zwischenwerte, Tempo, Pfeiltasten und dass
// Wischen weiterhin aus ist.
(function () {
  var wurzel = document.getElementById('ns-infinity-reviews');
  if (!wurzel || wurzel.dataset.nsRevInit) return;
  wurzel.dataset.nsRevInit = '1';

  var schiene = wurzel.querySelector('.ns-rev-rail');
  if (!schiene) return;

  // WARUM DER LAUF AN transform HAENGT, NICHT AN scrollLeft
  //
  // Vorher schob der Takt scrollLeft weiter. Gemessen wurde dabei: 60 Bilder je
  // Sekunde, kein einziger Aussetzer — und trotzdem sichtbares Ruckeln. Die
  // Messung sagt auch warum: JEDER Schritt war exakt 1 px. scrollLeft rastet
  // auf ganze Geraetepixel, Zwischenwerte gehen verloren. Bei ruhigem Tempo
  // waeren rund 0,4 px je Bild faellig — daraus macht die Rundung ein
  // Stehen-Stehen-Springen. Langsamer stellen haette es SCHLIMMER gemacht.
  //
  // Dazu kam ein zweiter Fehler: das eigene Schreiben von scrollLeft loeste ein
  // scroll-Ereignis aus, das ERST NACH dem Zuruecksetzen der Merkvariablen
  // ankam. Der Zuhoerer hielt den eigenen Lauf fuer eine Handbewegung und
  // schrieb die gerundete Position zurueck — die Schiene lief dadurch mit
  // 60 px/s statt der eingestellten 35 px/s.
  //
  // transform kennt Zwischenwerte, wird von der Grafikkarte gezeichnet und
  // loest kein scroll-Ereignis aus. Beide Fehler sind damit weg.
  //
  // WISCHEN IST SEIT DEM 01.09.2026 AUS. Vorgabe des Haendlers: "zum blaettern
  // nach rechts wischen soll nicht gehen und auch nicht da stehen". Das CSS
  // setzt .ns-rev-rail deshalb auf overflow-x: hidden, der Hinweistext unter
  // der Ueberschrift ist entfallen. Damit ist scrollLeft dauerhaft 0 und der
  // Lauf die einzige Bewegung — der frueher noetige Zuhoerer auf scroll und
  // das Zurueckholen ueber die Naht sind ersatzlos weg.

  // Alle Karten wandern in eine eigene Spur — bewegt wird ab jetzt die Spur.
  var spur = document.createElement('div');
  spur.className = 'ns-rev-track';
  spur.style.display = 'flex';
  spur.style.flex = '0 0 auto';
  spur.style.backfaceVisibility = 'hidden';
  while (schiene.firstChild) spur.appendChild(schiene.firstChild);
  schiene.appendChild(spur);

  var satz = Array.prototype.slice.call(spur.children);
  if (!satz.length) return;

  // ZWEI Kartensaetze. Solange auch von Hand gewischt werden konnte, brauchte es
  // drei: Handbewegung und Lauf addierten sich und konnten zusammen ueber das
  // Spurende hinauszeigen. Ohne Wischen bleibt nur der Lauf, und der wandert nie
  // weiter als einen Satz — der zweite Satz deckt also immer, was rechts
  // nachrueckt. Ein dritter waere 15 Karten Ballast ohne Wirkung.
  var kopie = document.createDocumentFragment();
  for (var i = 0; i < satz.length; i++) {
    var doppel = satz[i].cloneNode(true);
    // Reine Sehhilfe: sonst liest ein Screenreader jede Bewertung doppelt.
    doppel.setAttribute('aria-hidden', 'true');
    var knoepfe = doppel.querySelectorAll('a, button');
    for (var j = 0; j < knoepfe.length; j++) knoepfe[j].tabIndex = -1;
    kopie.appendChild(doppel);
  }
  spur.appendChild(kopie);

  // Die Luecke steht im CSS auf .ns-rev-rail und wechselt mit der Fensterbreite.
  // Die Spur muss sie uebernehmen, sonst kleben die Karten aneinander.
  function luecke() {
    var stil = getComputedStyle(schiene);
    return parseFloat(stil.columnGap || stil.gap) || 0;
  }
  function lueckeUebernehmen() { spur.style.gap = luecke() + 'px'; }

  // Karten haengen mobil am Fenster (`flex: 0 0 86vw`). Reihenfolge zaehlt:
  // Luecke, dann messen, dann Position in die Strecke holen — sonst springt
  // es an der Naht.
  function neuVermessen() {
    lueckeUebernehmen();
    messen();
    if (_satzbreite > 0) { while (pos >= _satzbreite) pos -= _satzbreite; setzen(); }
  }
  neuVermessen();

  // Gemessen wird nur noch bei Fensteraenderung. Vorher lief satzbreite() in
  // JEDEM Bild: 19 Messungen je Bild, 60 Mal je Sekunde, direkt nach dem
  // transform — 60 erzwungene Layouts je Sekunde. Siehe HANDBUCH Abschnitt 30.
  var _kartenbreite = 0;
  var _satzbreite = 0;

  function messen() {
    var g = luecke(), b = 0;
    for (var i = 0; i < satz.length; i++) b += satz[i].getBoundingClientRect().width + g;
    _satzbreite = b;
    _kartenbreite = Math.round(satz[0].getBoundingClientRect().width + g);
  }

  // Die Erstmessung beim Start liefert 0, solange das Dokument noch geparst
  // wird und die Karten noch keine Breite haben. Deshalb messen beide erst
  // dann wirklich, wenn noch kein brauchbarer Wert vorliegt — danach nie
  // wieder von selbst, sondern nur noch bei einer Fensteraenderung.
  function kartenbreite() { if (!_kartenbreite) messen(); return _kartenbreite; }
  function satzbreite() { if (!_satzbreite) messen(); return _satzbreite; }

  // Pixel je Millisekunde. 0.022 sind rund 22 px/s — eine Karte laeuft in gut
  // 15 Sekunden durch. Gemessen waren es vorher 60 px/s.
  // 0.035 ist der Wert vom 29.08.2026, also rund 35 px/s. Am 01.09. wurde er
  // auf 0.022 gesenkt, weil vorher 60 px/s GEMESSEN wurden — die kamen aber
  // aus einem Fehler in der alten scrollLeft-Fassung, nicht aus der Einstellung.
  var TEMPO = 0.035;
  var laeuft = true;
  var taktAn = true;
  // Ohne diesen Merker startet die Rueckkehr aus einem anderen Tab den Lauf
  // auch dann, wenn die Schiene nicht im Bild ist.
  var imBild = true;
  var pos = 0;
  var zuletzt = 0;
  var pauseBis = 0;
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setzen() { spur.style.transform = 'translate3d(' + (-pos).toFixed(2) + 'px, 0, 0)'; }

  function takt(zeit) {
    if (!zuletzt) zuletzt = zeit;
    var dt = zeit - zuletzt;
    zuletzt = zeit;
    // Nach einem Tabwechsel liefert das erste Bild eine riesige Zeitspanne —
    // deckeln, sonst springt die Schiene beim Zurueckkommen weit nach vorn.
    if (dt > 60) dt = 60;

    if (laeuft && zeit > pauseBis && !ruhig.matches) {
      var h = satzbreite();
      pos += TEMPO * dt;
      if (h > 0) { while (pos >= h) pos -= h; }
      setzen();
    }
    // Bei reduzierter Bewegung endet die Schleife jetzt ganz, statt weiter
    // 60 Mal je Sekunde ein Bild anzufordern.
    if (laeuft && !ruhig.matches) requestAnimationFrame(takt);
    else taktAn = false;
  }

  function anhalten() {
    laeuft = false;
    // will-change nur waehrend des Laufs — die Spur ist rund 12.900px breit.
    spur.style.willChange = 'auto';
  }
  function weiter() {
    if (!imBild || document.hidden || ruhig.matches) return;
    laeuft = true;
    spur.style.willChange = 'transform';
    // zuletzt zuruecksetzen, sonst sieht das erste Bild nach der Pause die
    // ganze Standzeit als Zeitspanne.
    if (!taktAn) { taktAn = true; zuletzt = 0; requestAnimationFrame(takt); }
  }
  // Umschalten der Bewegungsvorgabe greift sofort, in beide Richtungen.
  if (ruhig.addEventListener) ruhig.addEventListener('change', function () { if (ruhig.matches) anhalten(); else weiter(); });

  // Beim Lesen anhalten: Maus darueber, Tastaturfokus, Finger auf der Schiene.
  // Der Finger kann nicht mehr wischen, das Antippen haelt aber weiter an —
  // wer eine Karte zu Ende lesen will, tippt sie an.
  schiene.addEventListener('mouseenter', anhalten);
  schiene.addEventListener('mouseleave', weiter);
  schiene.addEventListener('focusin', anhalten);
  schiene.addEventListener('focusout', weiter);
  schiene.addEventListener('touchstart', anhalten, { passive: true });
  schiene.addEventListener('touchend', function () { pauseBis = performance.now() + 2500; weiter(); }, { passive: true });

  // Ausserhalb des Sichtfelds nicht rechnen.
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      for (var i = 0; i < e.length; i++) {
        imBild = e[i].isIntersecting;
        if (imBild) weiter(); else anhalten();
      }
    }, { threshold: 0 }).observe(schiene);
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) anhalten(); else { zuletzt = 0; weiter(); }
  });

  // Die Pfeiltasten bleiben — sie sind jetzt der EINZIGE Weg, von Hand
  // weiterzublaettern, und damit der Zugang fuer alle, die nicht auf den
  // Selbstlauf warten wollen oder koennen. Geblaettert wird am Laufstand:
  // die Strecke wiederholt sich, deshalb geht es auch nach links weiter.
  function blaettern(richtung) {
    // Nach einem Sprung kurz stehen bleiben, damit die Karte gelesen werden kann.
    pauseBis = performance.now() + 2500;
    var h = satzbreite();
    var ziel = pos + richtung * kartenbreite();
    if (h > 0 && (ziel >= h || ziel < 0)) {
      // Ueber die Naht: hart setzen. Dort steht dasselbe Bild, der Sprung ist
      // unsichtbar — weich waere ein Ruecklauf ueber die ganze Strecke.
      while (ziel >= h) ziel -= h;
      while (ziel < 0) ziel += h;
      pos = ziel;
      setzen();
      return;
    }
    spur.style.transition = 'transform 420ms cubic-bezier(.22,.61,.36,1)';
    pos = ziel;
    setzen();
    setTimeout(function () { spur.style.transition = ''; }, 460);
  }
  schiene.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); blaettern(1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); blaettern(-1); }
  });

  window.addEventListener('resize', neuVermessen);

  // Fuer die Pruefwerkzeuge: Laufstand und Wiederholstrecke ablesbar machen,
  // ohne den Stil-String zu zerlegen. scripts/check-slider.mjs nutzt beides.
  schiene.nsLaufstand = function () { return pos; };
  schiene.nsSatzbreite = satzbreite;

  setzen();
  requestAnimationFrame(takt);
})();
